import React from 'react';
import { Shield, Lock, Mail, FileCheck } from 'lucide-react';
import PolicySectionCard from '@/components/policy/PolicySectionCard';
import PageHeader from '@/components/layout/PageHeader';
import PolicyLayout from '@/components/policy/PolicyLayout';
import { motion } from 'framer-motion';

const GDPRCompliance = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    show: { y: 0, opacity: 1 }
  };

  return (
    <PolicyLayout>
      <PageHeader
        title="GDPR Compliance Statement"
        description="Last updated: April 11, 2025"
        icon={<Shield className="w-8 h-8 text-primary" />}
      />

      {/* Cards Grid */}
      <motion.div 
        className="space-y-6"
        variants={container}
        initial="hidden"
        animate="show"
      >
        <motion.div variants={item}>
          <PolicySectionCard
            title="Our Commitment"
            icon={Shield}
            variant="purple"
          >
            <p>Cibeto Technologies Pvt Ltd is fully committed to complying with the General Data Protection Regulation (GDPR) for EU-based users.</p>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Key Points"
            icon={Lock}
            variant="teal"
          >
            <ul className="list-disc pl-6 space-y-2">
              <li>We collect only essential user data and obtain clear consent</li>
              <li>Users can access, modify, or delete their data</li>
              <li>Data is securely stored and encrypted</li>
              <li>We do not share personal data without consent, except under legal obligation</li>
            </ul>
          </PolicySectionCard>
        </motion.div>

        <motion.div variants={item}>
          <PolicySectionCard
            title="Contact"
            icon={Mail}
            variant="rose"
          >
            <p>To make a GDPR request, email: gdpr@edaptica.com</p>
          </PolicySectionCard>
        </motion.div>
      </motion.div>
    </PolicyLayout>
  );
};

export default GDPRCompliance;
